import React from 'react'
import { FText as BaseFText } from 'f-web/src/components'
import { colors } from 'styles'

export default function FText(props) {
  return <BaseFText rubik color={colors.backgroundText} {...props} />
}
